import { FC } from 'react';
import { Divider, Typography } from 'antd';
import styled from 'styled-components';
import { StatusField } from '@/entities/proc';
import { ProcDetailsResponse } from '@/shared/api';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { PageLayoutHeaderGoBackBtn } from '@/widgets/page-layout';

const { Title } = Typography;

type Props = {
  proc?: ProcDetailsResponse;
};

export const ProcInstancesPageHeader: FC<Props> = ({ proc }) => {
  const { theme } = useThemeContext();

  return (
    <HeaderWrapper>
      <PageLayoutHeaderGoBackBtn
        path={`/dashboard/author/proc/${proc?.id}`}
        label="Go back to proc"
      />
      <TitleWrapper>
        <Title
          level={5}
          ellipsis={{ rows: 2, expandable: false }}
          style={{
            fontWeight: 400,
            textOverflow: 'ellipsis',
            lineHeight: '1.1',
            overflow: 'hidden',
            margin: 0,
          }}
        >
          {proc?.title}
        </Title>
      </TitleWrapper>
      <div>
        <StatusField
          status={proc?.state!}
          style={{ display: 'inline-block' }}
        />
        <Divider
          type="vertical"
          style={{
            fontSize: 35,
            borderInlineStart: `1px solid ${themeConfig[theme].colors.border}]}`,
            top: 0,
            marginLeft: 20,
          }}
        />
      </div>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled.div`
  width: 60%;
  padding-inline: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
